<script>
    export let loading = false;
</script>

<style>
    .til span {
        font-size: 3rem;
        font-weight: bold;
        color: #4e598c;
        display: inline-block;
        animation: pulse 1.5s infinite;
    }

    .til span:nth-child(1) { animation-delay: 0s; } /* "T" */
    .til span:nth-child(2) { animation-delay: 0.2s; } /* "I" */
    .til span:nth-child(3) { animation-delay: 0.4s; } /* "L" */

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
            opacity: 1;
        }
        50% {
            transform: scale(2);
            opacity: 0.7;
        }
    }
</style>

{#if loading}
    <div class="items-center">
        <div class="til">
            <span>T</span><span>I</span><span>L</span>
        </div>
    </div>
{/if}